/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './related-data-location.component.html';
import {CHART_IMPORTS} from './chart-imports';
import {LineChartComponent} from './line-chart.component';
import {PerfTotalComponent} from './perf-total-component';

@Component({
  imports: [...CHART_IMPORTS, LineChartComponent, PerfTotalComponent],
  selector: 'adn-related-data-location',
  template
})
export class RelatedDataLocationComponent {
  @Input() allStats: any;
  @Input() countType: any;
  @Input() relatedChartData: any;
  @Input() changeHook: any;
  @Input() chartType: string;
  @Input() locationsEmpty = false;
  @Input() isPending = false;
}
